import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback, MessageAlert, Loader, DataTableHoc } from 'smart-react';
import { AFFECTEDFILESDETAILS } from '../../../constants/applicationConstants';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import { Card } from '@progress/kendo-react-layout';

import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../constants/applicationConstants';

import {
  deleteFilter,
  applyFilter,
  saveFilters,
} from '../../../Utils/Filters/filterSliderHandler';

const BaseAffectedFileDetailDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable')
);
const AffectedFileDetailDataTable = DataTableHoc(
  BaseAffectedFileDetailDataTable
);

/**
 * AffectedFileDetail main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The AffectedFileDetail component.
 */
const AffectedFileDetail = () => {
  const [loading, setLoading] = useState(false);
  const [rolloutsData, setRolloutsData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  const [alertMessage, setAlertMessage] = React.useState({
    alert: false,
    message: null,
  });
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <React.Suspense fallback={<Loader />}>
        {loading && <Loader />}
        {alertMessage?.alert && (
          <MessageAlert
            type={'danger'}
            message={alertMessage.message}
            isIcon={true}
            iconName={'error'}
          />
        )}
        <div className="container mx-auto account-form-container">
          <div className="add-test add-test-page cards-layout-page container mx-auto">
            <div className="card-detail-content">
              <Card className="seprate-card">
                <div className="card-content">
                  <AffectedFileDetailDataTable
                    deleteFilter={deleteFilter}
                    applyFilter={applyFilter}
                    saveFilters={saveFilters}
                    moduleName={AFFECTEDFILESDETAILS}
                    dataColumns={dataColumnsArray}
                    gridColumnsList={GridColumnsList}
                    dataTableName={AFFECTEDFILESDETAILS}
                    setIsReady={setIsReady}
                    isReady={isReady}
                    rowLayoutConfigName={`${AFFECTEDFILESDETAILS}.DataGrid.RowLayout`}
                    pageLengthConfigName={`${AFFECTEDFILESDETAILS}.DataGrid.ItemsPerPage`}
                    dataSet={rolloutsData}
                    setDataSet={setRolloutsData}
                    initialSort={{
                      field: 'rn',
                      dir: 'asc',
                    }}
                    isCardonMobileView={false}
                    total={process.env.DefaultLimit}
                    defaultRowLayout={process.env.RowLayout}
                    rowLayouts={ROW_LAYOUTS}
                    pageSizes={PAGE_SIZE}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </React.Suspense>
    </ErrorBoundary>
  );
};
export default AffectedFileDetail;
